// extracted by mini-css-extract-plugin
export var orderSummary = "_n0-0";
export var showMoreLessButton = "_n0-1";